import script from "./OCabecalhoPeriodoEntreDatas.vue?vue&type=script&setup=true&lang=ts"
export * from "./OCabecalhoPeriodoEntreDatas.vue?vue&type=script&setup=true&lang=ts"

import "./OCabecalhoPeriodoEntreDatas.vue?vue&type=style&index=0&id=6a17467d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a17467d"]])

export default __exports__